import { render, staticRenderFns } from "./ImageCropper.vue?vue&type=template&id=84b56b52&scoped=true"
import script from "./ImageCropper.vue?vue&type=script&lang=js"
export * from "./ImageCropper.vue?vue&type=script&lang=js"
import style0 from "./ImageCropper.vue?vue&type=style&index=0&id=84b56b52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b56b52",
  null
  
)

export default component.exports